import React, { FC } from 'react';
import { Button, Typography, Unstable_Grid2 as Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Form as FormikForm, Formik, FormikHelpers } from 'formik';

import {
  ClientDisclosureStatus,
  CreateClientDisclosureInput,
  useCreateClientDisclosureMutation,
} from 'api';
import { ValidatedTextFieldNext } from 'components';
import { useNotify } from 'hooks';
import { DisclosuresSchema } from 'features/admin/validations';
import { useCreateDisclosure } from 'features/admin/updaters';

const Create: FC = () => {
  const { t } = useTranslation();
  const notify = useNotify();

  const initialValues: CreateClientDisclosureInput = {
    disclosure: '',
    disclosure_status: ClientDisclosureStatus.Active,
  };

  const mutationOptions = useCreateDisclosure({ data: {} });
  const { mutateAsync: createClientDisclosureMutation } = useCreateClientDisclosureMutation({
    onSuccess: () => notify.info({ message: t('admin:disclosureCreateNotification') }),
    ...mutationOptions,
  });

  async function handleSubmit(
    values: CreateClientDisclosureInput,
    helpers: FormikHelpers<CreateClientDisclosureInput>
  ) {
    helpers.resetForm();
    await createClientDisclosureMutation({ data: values });
  }

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={DisclosuresSchema}
      onSubmit={handleSubmit}
    >
      <FormikForm>
        <Grid container alignItems="center" marginBottom={2}>
          <Grid xs={3}>
            <Typography variant="subtitle2">{t('admin:disclosures')}</Typography>
          </Grid>
          <Grid xs={7} container alignItems="center">
            <Grid xs={11}>
              <ValidatedTextFieldNext
                name="disclosure"
                placeholder={t('admin:addDisclosure')}
                color="primary"
                fullWidth
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
            <Grid xs={1} />
          </Grid>
          <Grid xs={2}>
            <Button type="submit" size="large" variant="contained" color="primary" fullWidth>
              {t('common:add')}
            </Button>
          </Grid>
        </Grid>
      </FormikForm>
    </Formik>
  );
};

export default Create;
